import React, { useEffect } from 'react'
import ProductCard from '../../dynamicUi/elements/products/ProductCard'
import ProductLoader from '../../dynamicUi/elements/products/ProductLoader'
import FormLabel from 'components/form/FormLabel'

const ProductViewer = ({
  data = [],
  onRemove,
  type,
  loading,
  hasRemove = true,
  className,
  isCartItem = true
}) => {

  return (
    <div>
      {!data.length && !loading ? (
        <></>
      ) : (
        <div className={`py-3 space-y-1 ${className ? className : ""}`}>
          {hasRemove && isCartItem && <FormLabel label="Cart Items"/>}
           {loading
            ? Array.from({ length: 2 }, (_, i) => (
                <ProductLoader key={`specials-loader-${i}`} isHorizontal={true}/>
              ))
            : data?.map((product, i) => (
                <ProductCard
                  isHorizontal= {true}
                  onRemove={
                    hasRemove
                      ? () => {
                          onRemove(type, product)
                        }
                      : null
                  }
                  mobile={false}
                  product={product}
                  key={`${product.product_id}-${i}-${type}`}
                />
              ))}
        </div>
      )}
    </div>
  )
}

export default ProductViewer
